var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("table", [
      _c("tbody", [
        _c("tr", [
          _c("td", { staticClass: "hh", attrs: { colspan: "2" } }, [
            _vm._v("Term - " + _vm._s(_vm._term_name))
          ]),
          _vm._v(" "),
          _c("td", { staticClass: "hh" }, [_vm._v("Machine 1")]),
          _vm._v(" "),
          _c("td", { staticClass: "hh" }, [_vm._v("Machine 2")]),
          _vm._v(" "),
          _c("td", { staticClass: "hh" }, [_vm._v("Machine 3")]),
          _vm._v(" "),
          _c("td", { staticClass: "hh" }, [_vm._v("Machine 4")])
        ]),
        _vm._v(" "),
        _vm._m(0),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Proposed Costs")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (
                      _vm.getCurrentCostValue("equipment_lease_costs") / 4
                    ).toFixed(2)
                  )
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    (
                      _vm.getCostValueByTerm(man, "total_equipment_cost") -
                      _vm.getCostValueByTerm(man, "settlement_cost")
                    ).toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Settlement Costs")]),
            _vm._v(" "),
            _c("td", [_vm._v("N/A")]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getCostValueByTerm(man, "settlement_cost").toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Proposed Service Costs")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (_vm.getCurrentCostValue("service_costs") / 4).toFixed(2)
                  )
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getCostValueByTerm(man, "total_service_cost").toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [
              _vm._v("TOTAL PROPOSED COST INCLUDING SERVICE YEAR ONE")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (
                      (_vm.getCurrentCostValue("equipment_lease_costs") +
                        _vm.getCurrentCostValue("service_costs")) /
                      4
                    ).toFixed(2)
                  )
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    (
                      _vm.getCostValueByTerm(man, "total_equipment_cost") +
                      _vm.getCostValueByTerm(man, "settlement_cost") +
                      _vm.getCostValueByTerm(man, "total_service_cost")
                    ).toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c("tr", [
          _c("td", { staticClass: "h" }, [_vm._v("Invoice Fees")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              " " +
                _vm._s((_vm.getCurrentCostValue("invoice_fees") / 4).toFixed(2))
            )
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")])
        ]),
        _vm._v(" "),
        _c("tr", [
          _c("td", { staticClass: "h" }, [_vm._v("Insurance Fees")]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              " " +
                _vm._s(
                  (_vm.getCurrentCostValue("insurance_fees") / 4).toFixed(2)
                )
            )
          ]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")]),
          _vm._v(" "),
          _c("td", [_vm._v("N/A")])
        ]),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Postage Reset Fees")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (
                      _vm.getCurrentCostValue("postage_recredit_costs") / 4
                    ).toFixed(2)
                  )
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getCostValue(man, "postage_recredit_costs").toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Consumable Ink Costs")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (
                      _vm.getCurrentCostValue("consumable_ink_costs") / 4
                    ).toFixed(2)
                  )
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getCostValue(man, "consumables_ink_cost").toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Consumable Label Costs")]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (
                      _vm.getCurrentCostValue("consumable_label_costs") / 4
                    ).toFixed(2)
                  )
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getCostValue(man, "consumable_label_cost").toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [_vm._v("Postage Savings")]),
            _vm._v(" "),
            _c("td"),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(_vm.getCostValue(man, "postage_savings").toFixed(2))
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [
              _vm._v("TOTAL INVESTMENT PER QUARTER")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                " " +
                  _vm._s(
                    (_vm.getTotalInvestmentPerAnnumForCurrent() / 4).toFixed(2)
                  ) +
                  " "
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  " " +
                    _vm._s(
                      (
                        _vm.getTotalInvestmentPerAnnumForMachine(man) / 4
                      ).toFixed(2)
                    ) +
                    " "
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [
              _vm._v("TOTAL INVESTMENT PER ANNUM")
            ]),
            _vm._v(" "),
            _c("td", [
              _vm._v(
                _vm._s(_vm.getTotalInvestmentPerAnnumForCurrent().toFixed(2))
              )
            ]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    _vm.getTotalInvestmentPerAnnumForMachine(man).toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "tr",
          [
            _c("td", { staticClass: "h" }, [
              _vm._v("TOTAL SAVINGS VS CURRENT AGREEMENT OVER TERM")
            ]),
            _vm._v(" "),
            _c("td", [_vm._v("N/A")]),
            _vm._v(" "),
            _vm._l([2, 3, 4, 5], function(man) {
              return _c("td", [
                _vm._v(
                  _vm._s(
                    (
                      (_vm.getTotalInvestmentPerAnnumForCurrent() -
                        _vm.getTotalInvestmentPerAnnumForMachine(man)) *
                      (_vm.term ? _vm.term + 1 : 5)
                    ).toFixed(2)
                  )
                )
              ])
            })
          ],
          2
        ),
        _vm._v(" "),
        _vm._m(2)
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "h" }),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("CURRENT PRICING")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("PITNEY BOWES RATES VIA DMS")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [
        _vm._v("QUADIENT (NEOPOST) RATES VIA DMS")
      ]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("FP RATES VIA DMS")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("FRAMA RATES VIA DMS")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "h" }, [_vm._v("MACHINE MODEL:")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("Current model")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("New Costs Machine 1 model")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("New Costs Machine 2 model")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("New Costs Machine 3 model")]),
      _vm._v(" "),
      _c("td", { staticClass: "h" }, [_vm._v("New Costs Machine 4 model")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", [
      _c("td", { staticClass: "h" }, [_vm._v("DEAL MARGIN")]),
      _vm._v(" "),
      _c("td", [_vm._v("N/A")]),
      _vm._v(" "),
      _c("td"),
      _vm._v(" "),
      _c("td"),
      _vm._v(" "),
      _c("td"),
      _vm._v(" "),
      _c("td")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0c16b8b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c16b8b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/ProposalTemplate/Partials/LeaseOptionsTable.vue
// module id = null
// module chunks = 